import Error from 'next/error';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import ChangePasswordSection from '@/src/account/components/ChangePassword';
import MyAccount from '@/src/account/components/MyAccount';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import withAuthentication from '@/src/shared/components/WithAuthentication';
import request from '@/utils/axios';

function ChangePassword(props) {
  const { error, isLoggedIn } = props;

  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchPageData = async () => {
    const response = await request({
      url: `cms/designpage`,
      params: {
        alias: 'change-password',
      },
    });
    setPageData(response.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchPageData();
  }, []);

  if (loading) {
    return null;
  }
  if (error) {
    return <Error />;
  }

  return (
    <Layout>
      <AdminLink pageID="522" pageType="core" />
      <Section bgColor="gray" halfPad>
        <Container>
          <MyAccount mainContent={<ChangePasswordSection />} />
          <WebLogImage
            path="/account/change-password"
            title="Change My Password"
            pagedata={pagedata}
          />
        </Container>
      </Section>
    </Layout>
  );
}

const mapStateToProps = state => {
  const {
    auth: { isLoggedIn },
  } = state;

  return {
    isLoggedIn,
  };
};

export default connect(
  mapStateToProps,
  null
)(withAuthentication(ChangePassword));
